<template>

	<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

		<h2>Painel do Advogado</h2>

		<div style="text-align: right; width: 100%;" class="mb-5">
			<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; cursor: pointer;" @click="NovoProcesso()">
				<span class="material-icons" style="vertical-align: middle; color: #007BFF; cursor: pointer;">insert_drive_file</span>
				<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Petição inicial</label>
			</button>
			<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 200px;">
				<span class="material-icons" style="vertical-align: middle; color: #007BFF;">skip_previous</span>
				<label style="color: #007BFF; vertical-align: middle;">Últimas movimentações</label>
			</button>
			<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 200px;">
				<span class="material-icons" style="vertical-align: middle; color: #007BFF;">list</span>
				<label style="color: #007BFF; vertical-align: middle;" @click="ConsultaProcesso()">Relação de processos</label>
			</button>
		</div>


		<p style="text-align: center; color: brown; font-size: 18px; font-weight: bold;">COMUNICADO DO CNJ SOBRE PRAZOS PROCESSUAIS</p>
		<p style="font-weight: bold;">A partir de 16/05, todos os prazos processuais serão pelas publicações do Diário de Justiça Eletrônica Nacional ou pelo Domicílio Judicial Eletrônico, sendo outras comunicações meramente informativas. Para saber mais, <a>clique aqui</a>.</p>
		<p style="color: red; font-weight: bold;">
			Atenção!
		</p>
		<p>
		<ul>
			<li>A classe AGRAVO DE INSTRUMENTO <strong>não será disponibilizada</strong> para as Turmas Recursais. Isso porque as classes processuais são habilitadas rigorosamente <strong>conforme o disposito nas Tabelas Processuais do Conselho Nacional de Justiça</strong> (TPUs). Em contrapartida,e conforme previsto nas TPUs, a classe já habilitada para fins de recurso das decisões que deferem e indeferem as medidas cautelares ou antecipatórias é RECURSO DE MEDIDA CAUTELAR CÍVEL. <strong>Esta
					opção está disponível na caixa AÇÕES do processo de 1º grau, como RECURSO DE MEDIDA CAUTELAR.</strong></li>
			<li v-if="EPROC_ESTADO == 'RS'">Tratando-se de ação/petição envolvendo o evento climático extremo ocorrido entre abril e maio de 2024 no Estado do Rio Grande do Sul, também ASSINALE o <i>assunto complementar</i> <strong>"Enchentes no Rio Grande do Sul em 2024"</strong> na classificação processual (Portaria nº 161 de 09 de maioo de 2024 do CNJ).</li>
		</ul>
		</p>

		<!-- A seguir, antes da atualização do texto feita em 17/11/2025  -->
		<!--
        <p>Senhor Advogado e Senhora Advogada</p>
        <p>A classe AGRAVO DE INSTRUMENTO <strong>não está disponível</strong> para Turmas Recursais, conforme disposto nas <strong>Tabelas Processuais Unificadas do Conselho Nacional de Justiça</strong>.</p>
        <p>Para o recurso previsto na primeira parte do art. 4º a Lei 12.153/2009 (Juizados Especiais da Fazenda Pública) <strong>está disponível</strong> a classe RECURSO DE MEDIDA CAUTELAR CÍVIL.</p>
        <p>Nos Juizados Especiais Cíveis <strong>está habilitada</strong> a classe MANDADO DE SEGURANÇA CÍVEL.</p>
        <p><strong>Essas opções estão disponíveis na caixa AÇÕES do processo de 1º grau</strong>.</p>-->




		<div class="container mt-5 mb-5">
			<div class="row custom-callout">

				<!-- COLUNA ESQUERDA -->
				<div class="col-12 col-md-6">

					<!-- Citações/Intimações -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: #007BFF;">
							<div class="card-header" data-toggle="collapse" href="#collapseCitacoes" style="color: #007BFF;">
								<strong>Citações/Intimações</strong>
							</div>
							<div id="collapseCitacoes" class="collapse show">
								<div class="card-body">

									<ul class="nav nav-tabs">
										<li class="nav-item">
											<a class="nav-link active" aria-current="page" href="#">
												<strong>{{ EPROC_ESTADO }}</strong>
											</a>
										</li>
									</ul>

									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Tipo</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Processo com prazo em aberto</td>
												<td class="text-center"><a :href="`${BASE_URL}processo_prazos?t=abertos`">{{ qtdPrazosAbertos }}</a></td>
											</tr>
											<tr>
												<td>Processo com prazo em aberto - urgente</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Processos pendentes de citação/intimação - Urgentes</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Processos pendentes citação/intimação</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Processos pendentes de intimação de homologação de acordo</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Processos pendentes de citação - art 334 CPC</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Decursos de prazo nos últimos 30 dias</td>
												<td class="text-center"><a :href="`${BASE_URL}processo_prazos?t=decurso`">{{ qtdDecursoPrazo }}</a></td>
											</tr>
										</tbody>
									</table>
									<p style="font-size: small; color: black; text-align: right; font-weight: bold;">
										<span class="material-icons" style="font-size: medium; font-weight: bold;">alarm</span>&nbsp;&nbsp;Processos com prazo vencendo hoje: <a href="#">0</a>
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- Sessões de Julgamento -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: green;">
							<div class="card-header" data-toggle="collapse" href="#collapseSessoes" style="color: green;">
								<strong>Sessões de Julgamento</strong>
							</div>
							<div id="collapseSessoes" class="collapse show">
								<div class="card-body">
									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Tipo</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Processos em pauta</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<!-- Área de trabalho -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: #020202;">
							<div class="card-header" data-toggle="collapse" href="#collapseAreaTrabalho">
								<strong>Área de trabalho</strong>
							</div>
							<div id="collapseAreaTrabalho" class="collapse show">
								<div class="card-body">
									<ul class="nav nav-tabs">
										<li class="nav-item">
											<a class="nav-link active" aria-current="page" href="#"><strong>Pendências</strong></a>
										</li>
										<li class="nav-item">
											<a class="nav-link" aria-current="page" href="#">Substabelecimento</a>
										</li>
									</ul>

									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Tipo</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Processos pendentes do advogado</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Movimentações/petições pendentes para advogado</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

				</div> <!-- /COLUNA ESQUERDA -->

				<!-- COLUNA DIREITA -->
				<div class="col-12 col-md-6">

					<!-- Audiências/Fóruns de Conciliações/Perícias -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: #DC3545;">
							<div class="card-header" data-toggle="collapse" href="#collapseAudiencias" style="color: #DC3545;">
								<strong>Audiências/Fóruns de Conciliações/Perícias</strong>
							</div>
							<div id="collapseAudiencias" class="collapse show">
								<div class="card-body">
									<ul class="nav nav-tabs">
										<li class="nav-item">
											<a class="nav-link active" aria-current="page" href="#"><strong>Audiências</strong></a>
										</li>
										<li class="nav-item">
											<a class="nav-link" aria-current="page" href="#">Fóruns de Conciliações</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" aria-current="page" href="#">Perícias</a>
										</li>
									</ul>

									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Situação</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Audiências Futuras&nbsp;<span class="material-icons" style="font-size: small;">help</span></td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Audiências Futuras de Conciliação&nbsp;<span class="material-icons" style="font-size: small;">help</span></td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
										</tbody>
									</table>
									<p style="font-size: small; color: black; text-align: right; font-weight: bold;">
										<span class="material-icons" style="font-size: medium; font-weight: bold;">alarm</span>&nbsp;&nbsp;Próxima audiência: <a href="#">SEM AUDIÊNCIAS</a>
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- Financeiro -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: green;">
							<div class="card-header" data-toggle="collapse" href="#collapseFinanceiro" style="color: green;">
								<strong>Financeiro</strong>
							</div>
							<div id="collapseFinanceiro" class="collapse show">
								<div class="card-body">
									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Descrição</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade de Processos</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Custas a pagar</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Depósitos judicias em Aberto</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Alvarás Eletrônicos dos Últimos 7 dias</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Alvarás Eletrônicos dos Últimos 60 dias</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
											<tr>
												<td>Alvarás por OP não Resgatados</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<!-- Recursos do Tribunal -->
					<div class="callout mb-4">
						<div class="card" style="border-left-color: #000000;">
							<div class="card-header" data-toggle="collapse" href="#collapseRecursos">
								<strong>Recursos do Tribunal</strong>
							</div>
							<div id="collapseRecursos" class="collapse show">
								<div class="card-body">
									<table class="table table-striped table-bordered mt-2 border">
										<thead>
											<tr class="text-center">
												<th scope="col" style="background-color: lightgrey;">Tipo</th>
												<th scope="col" style="background-color: lightgrey;">Quantidade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Agravo de Instrumento Distribuído</td>
												<td class="text-center"><a href="#">0</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

				</div> <!-- /COLUNA DIREITA -->

			</div>
		</div>


		<div class="mb-3">
			<p class="font-weight-bold" style="font-size: small; background-color: lightgray;">
				<label style="color: red;"><strong>Atenção</strong></label><br />
				Senhores procuradores:<br />As citações, intimações e notificações serão todas realizadas diretamente no e-Proc. A emissão de email devido à inconstância do meio, tem caráter apenas informativo, não dispensando a consulta eletrônica direta ao sistema (art. 5º da Lei nº 11.419/2006).
			</p>
		</div>


		<!-- <p>{{ user }}</p> -->
	</div>
</template>

<script>
	export default {
		props: {
			user: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				EPROC_ESTADO: window.Laravel.EPROC_ESTADO,
				qtdPrazosAbertos: 0,
				qtdDecursoPrazo: 0,
			};
		},
		mounted() {
			this.BuscarProcessosPrazosAbertos();
			this.BuscarProcessosDecursoPrazo();
		},
		methods: {
			NovoProcesso() {
				window.location.href = this.BASE_URL + "processos/novo";
			},

			ConsultaProcesso() {
				window.location.href = this.BASE_URL + "processos/consultar";
			},

			async BuscarProcessosPrazosAbertos() {
				try {
					const { data } = await axios.get(this.BASE_URL + 'processos_prazos_abertos/resumo');
					this.qtdPrazosAbertos = data.total_processos; // ou total_processos, como preferir
				} catch (error) {
					console.error(error);
				}
			},

			async BuscarProcessosDecursoPrazo() {
				try {
					const { data } = await axios.get(this.BASE_URL + 'processos_decurso_prazo/resumo');
					this.qtdDecursoPrazo = data.total_processos;
				} catch (error) {
					console.error(error);
				}
			},
		}
	};
</script>

<style scoped>
	.custom-callout {
		display: flex;
	}

	.custom-callout .callout {
		flex: 1;
		margin-right: 10px;
	}

	.callout .card {
		border-left: 2px solid;
	}

	.callout .card-header {
		cursor: pointer;
	}
</style>
